import { render, staticRenderFns } from "./sky.vue?vue&type=template&id=8faeaf14&scoped=true&"
import script from "./sky.vue?vue&type=script&lang=js&"
export * from "./sky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faeaf14",
  null
  
)

export default component.exports